import React from "react";
import {Breadcrumb} from "antd";
import {
    AppstoreOutlined,
    CodeOutlined,
    SecurityScanOutlined,
    UnorderedListOutlined
} from "@ant-design/icons";
import "./moz.scss";
import {mozSystemsData} from "@store/mozSystemsData";
import {Link} from "react-router-dom";

const MOZ = () => {

    let cards = [
        {
            id: 1,
            backgroundColor: 'gray',
            title: 'АИК',
            icon:<CodeOutlined />,
            link: ''
        },
        {
            id: 2,
            backgroundColor: 'red',
            title: 'Скан',
            icon: <SecurityScanOutlined />,
            link: ''
        },
    ]

    return (
        <>
            <div className="breadcrumb">
                <Breadcrumb
                    style={{
                        margin: '16px 0',
                    }}
                >
                    <Breadcrumb.Item>
                        <UnorderedListOutlined/>
                        <span>Список</span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <AppstoreOutlined/>
                        <span>МОЗ</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
            </div>
            <div className="moz-container">
                <h1 className="moz-title">Виды мониторинга обеспечения защиты</h1>
                <div className="row">
                    {cards.map((card) => (
                        <div className="card-row" key={card.id}>
                            <Link to={`${card.link}`}>
                                <div className={`card card-hover ${card.backgroundColor}`}>
                                    <div className="card-body">
                                        <div className="card-icon">
                                            {card.icon}
                                        </div>
                                        <span className="card-title">{card.title}</span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
                <h1 className="moz-title">График проведения мониторинга обеспечения защиты</h1>
                <div className="card-container">
                    {mozSystemsData.map((system, index) => (
                        <div className="card" key={`Key${index}`}>
                            <h4 className="card-title">{system.month}</h4>
                            <ul className="schedule-list">
                                {system.description.map((description, index) => (
                                    <li className="schedule-item" key={`Key${index}`}>
                                        <span className="schedule-item-number">{description.number}</span>
                                        <span className="schedule-item-owner">{description.owner}</span>
                                        <span className="schedule-item-system">{description.name}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>


        </>
    )
}

export default MOZ;
